import { createRestApiClient, DataItem } from 'scrivito'

import { getInstanceIdFromUrl } from '@/utils/getInstanceIdFromUrl'

export const getAutomationsBaseUrl = (): string => {
  return 'https://edit.neoletter.com'
}

export const getAutomationsApiBaseUrl = (): string => {
  return 'https://api.justrelate.com/neoletter'
}

export const getAutomationsUrl = (): string => {
  const instanceId = getInstanceIdFromUrl()
  return `${getAutomationsBaseUrl()}/i/${instanceId}`
}

export const getAutomationsApiUrl = (): string => {
  const instanceId = getInstanceIdFromUrl()
  return `${getAutomationsApiBaseUrl()}/instances/${instanceId}`
}

export const isAutomationsItem = (dataItem: DataItem): boolean => {
  return dataItem.get('type') === 'MARKETING_AUTOMATION_EVENT'
}

export const getAutomationsLink = (
  dataItem: DataItem,
  includeReturnTo = true,
): string => {
  const automationsLink = `${getAutomationsUrl()}${dataItem.get('neoletterLink') || ''}`
  return addReturnToParam(automationsLink, includeReturnTo)
}

export const getAutomationsProfileLink = (
  profileId: string,
  includeReturnTo = true,
): string => {
  const automationsLink = `${getAutomationsUrl()}/audience/profiles/${profileId}`
  return addReturnToParam(automationsLink, includeReturnTo)
}

export const navigateToAutomations = (dataItem: DataItem, newTab?: boolean) => {
  const url = getAutomationsLink(dataItem, !newTab)
  navigate(url, newTab)
}

export const navigateToAutomationsProfile = (
  profileId: string,
  newTab?: boolean,
) => {
  const url = getAutomationsProfileLink(profileId, !newTab)
  navigate(url, newTab)
}

export const getAutomationsProfileIdByEmail = async (
  email: string,
): Promise<string | undefined> => {
  if (!email) {
    return undefined
  }

  const requestUrl = `${getAutomationsApiUrl()}/profiles/by-email`

  const client = createRestApiClient(requestUrl, {
    authViaInstance: getInstanceIdFromUrl(),
  })

  let response: { id: string | undefined } = { id: undefined }

  try {
    response = (await client.fetch(email)) as { id: string | undefined }
  } catch {
    // profile not existing
  }

  return response && response.id ? response.id : undefined
}

const addReturnToParam = (link: string, includeReturnTo = true): string => {
  if (link && includeReturnTo) {
    const returnTo = window.location.href

    const url = new URL(link)
    url.searchParams.set('return_to', returnTo)
    link = url.toString()
  }

  return link
}

const navigate = (url: string, newTab?: boolean) => {
  if (newTab) {
    window.open(url, '_blank')
  } else {
    window.open(url, '_self')
  }
}
